import MediaContent from "./MediaContent";

export default MediaContent;
